/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import { PaylineEvent } from '../Paylines/PaylineEvent';
import { StreakEvent } from '../StreakTracker/StreakEvent';
import IAnimationEventData from '../Utility/Component/Animation/IAnimationEventData';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

export enum SymbolAnimationOption
{
    Payline,
    Streak,
    Custom,
    ReelLand
}

/** Represents a symbol animation that responds to events. */
@cc._decorator.ccclass
export default class SymbolAnimation extends cc.Component implements IAnimationEventData
{
    /** What kind of symbol animation this represents. */
    @property({ type: cc.Enum(SymbolAnimationOption), visible: true })
    private _animationOption: SymbolAnimationOption = SymbolAnimationOption.Payline;
    public get AnimationOption(): SymbolAnimationOption { return this._animationOption; }
    /** @hidden */
    protected activeEventName: string = '';
    /** Accessor for the string name of the event which activates this animation. */
    @property()
    public get ActiveEventName(): string { return this.getAnimationActiveEventName(this._animationOption); }
    /** ActiveEventName to use when [[SymbolAnimationOption]] is set to Custom. */
    @property()
    protected customName: string = '';
    /** @hidden */
    protected clearEventName: string = '';
    /** Accessor for the string name of the event which clears this animation. */
    @property()
    public get ClearEventName(): string { return this.getAnimationClearEventName(this._animationOption); }
    /** ClearEventName to use when [[SymbolAnimationOption]] is set to Custom. */
    @property()
    protected customClearName: string = '';
    /** The string name of the animation to play on the symbol. */
    @property()
    public AnimationName: string = '';
    /** The node on which the symbol animation exists. */
    @property({ type: cc.Node })
    public AnimationNode: cc.Node = null;
    @property()
    public AudioCue: string = '';

    @property()
    public Loop: boolean = false;

    @property(cc.Integer)
    public Copies: number = 3;

    /** @hidden */
    protected onLoad(): void
    {
        if (!this.AnimationNode) { this.AnimationNode = this.node; }
    }

    /** @hidden */
    private getAnimationActiveEventName = (animationOption: SymbolAnimationOption): string =>
    {
        switch (animationOption)
        {
            case SymbolAnimationOption.Payline:
                return PaylineEvent.OnActive;
            case SymbolAnimationOption.Streak:
                return StreakEvent.OnStreak;
            case SymbolAnimationOption.Custom:
                return this.customName;
            case SymbolAnimationOption.ReelLand:
                return 'Reel.OnLanded';
        }
    }

    /** @hidden */
    private getAnimationClearEventName = (animationOption: SymbolAnimationOption): string =>
    {
        switch (animationOption)
        {
            case SymbolAnimationOption.Payline:
                return PaylineEvent.OnClear;
            case SymbolAnimationOption.Streak:
                return StreakEvent.OnClear;
            case SymbolAnimationOption.Custom:
                return this.customClearName;
            case SymbolAnimationOption.ReelLand:
                return '';
        }
    }
}
